// extracted by mini-css-extract-plugin
module.exports = {"button":"AppMenuButton_button__5j3oN"};